
import React, { useEffect } from 'react';
import {Form, Input, Button, Select, Spin, Switch} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';

import AdminLayout from "@/components/layout/admin/adminLayout";
import { URLS } from "@/lib/urls";
import { groupApi } from "@/api/group";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";

const { TextArea } = Input;

function AdminGroupEditPage() {
    const { id } = useParams();

    const [form] = Form.useForm();

    const { data: group, isLoading } = groupApi.useAdminGetGroup({id: id});

    const { mutate, isPending } = groupApi.useAdminUpdateGroup();

    useEffect(() => {
        if (group) {
            const item = group?.data?.data ?? group;

            form.setFieldsValue({
                title: item.title,
                desc: item.desc,
                status: item.status,
            });
        }
    }, [group, form]);

    const handleSubmit = (values) => {
        mutate(
            {
                id: Number(id),
                ...values,
            },
            {
                onSuccess: (res) => {
                    ApiHandleSuccessMessage(res)
                },
                onError: (err) => {
                    ApiHandleErrorMessage(err)
                }
            }
        );
    };

    if (isLoading) {
        return (
            <AdminLayout pageTitle="ویرایش گروه علمی" backTo={URLS.admin.group.list}>
                <div className="flex min-h-64 items-center justify-center">
                    <Spin size="large" />
                </div>
            </AdminLayout>
        );
    }

    return (
        <AdminLayout pageTitle={"ویرایش گروه علمی" + ' #' + group?.data?.data?.id} backTo={URLS.admin.group.list}>
            <div className="w-full p-4 sm:p-6">
                <div className="mx-auto w-full max-w-3xl rounded-xl border border-gray-200 dark:border-gray-700 p-4 shadow-sm sm:p-6 md:p-8">

                    <div className="mb-6">
                        <h2 className="text-lg font-bold sm:text-xl">
                            ویرایش اطلاعات گروه علمی
                        </h2>

                        <p className="mt-2 text-sm text-gray-500">
                            اطلاعات گروه علمی را ویرایش و ذخیره کنید.
                        </p>
                    </div>

                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleSubmit}
                        autoComplete="off"
                    >
                        <Form.Item
                            label="عنوان"
                            name="title"
                        >
                            <Input
                                size="middle"
                                placeholder="عنوان گروه علمی"
                                className="!rounded-lg"
                            />
                        </Form.Item>

                        <Form.Item
                            label="توضیحات"
                            name="desc"
                        >
                            <TextArea
                                rows={5}
                                placeholder="توضیحات گروه علمی را وارد کنید..."
                                className="!rounded-lg"
                            />
                        </Form.Item>

                        <Form.Item
                            label="وضعیت گروه"
                            name="status"
                            valuePropName="checked"
                            getValueProps={(value) => ({
                                checked: value === 'enable',
                            })}
                            getValueFromEvent={(checked) => (
                                checked ? 'enable' : 'disable'
                            )}
                        >
                            <Switch
                                checkedChildren="فعال"
                                unCheckedChildren="غیرفعال"
                            />
                        </Form.Item>

                        <div className="flex flex-col-reverse gap-3 border-t dark:border-gray-700 pt-5 sm:flex-row sm:justify-end">

                            <Button
                                type="primary"
                                htmlType="submit"
                                size="middle"
                                loading={isPending}
                                className="!rounded-lg"
                            >
                                ذخیره تغییرات
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
        </AdminLayout>
    );
}

export default AdminGroupEditPage;